import { Box, Text } from 'native-base';
export interface AnonymousModeInfoBoxProps {
  alias: string;
  color: string;
}

export const AnonymousModeInfoBox = ({
  alias,
  color,
}: AnonymousModeInfoBoxProps) => {
  return (
    <Box
      backgroundColor={'surface.200'}
      rounded={'lg'}
      p={5}
      textAlign={'center'}
    >
      <Text color={'surface.600'}>
        You are now known as{' '}
        <Text color={color} fontWeight={'bold'}>
          {alias}
        </Text>
        . In anonymous mode, your profile information is hidden and other users
        are unable to add you as a friend. You can toggle the switch to go back
        to public mode at any time. Stay on your best behavior, this mode does
        not make you immune to being reported.
      </Text>
    </Box>
  );
};
